import { makeStyles } from "@material-ui/core";
import L from "leaflet";
import React from "react";
import { Marker } from "react-leaflet";
import { urlConfig } from '../../../../config/urlConfig';

//style
const useStyle = makeStyles((theme) => {
  return {
    mapContainer: {
      height: 320,
    },
    memberIcon: {
      borderRadius: "50%",
    },
  };
});

export const MembersLocationMarker = ({ member }) => {
  const classes = useStyle();
  const { lat, lng, avatar } = member;

  return (
    <>
      <Marker icon={
        new L.Icon({
          iconUrl: avatar
            ? avatar
            : "/icons/default_profile.png",
          popupAnchor: null,
          className: classes.memberIcon,
          iconSize: [50, 50],
          iconAnchor: [12, 36],
          shadowAnchor: [4, 62],
        })
      } position={[lat, lng]} />
    </>
  );
};

